export default __webpack_public_path__ + "static/media/contact_us.1e85d6ce.jpg";